import {createClient} from "contentful";


const useContentful = () =>{
const client = createClient({
    space: 'uph78o1puxm1',
    accessToken: 'mn26qR6QAaU38TjYfOWlX-pgPIKUk-64in3-fhXWGVQ'

});
    const getContinents = async  () => {
        try {
            const continents = await client.getEntries({
                content_type: 'continents',

            });
           const continent = continents.items.map(item => {
               // @ts-ignore
               const country = item?.fields?.country?.map(itm => {
                   return {
                       // @ts-ignore
                       ...itm.fields
                   }
               })
               return {
                   // @ts-ignore
                   ...item.fields,
                   country
               }
           })
            return continent
        } catch (err) {
            console.log(err)
        }
    }
    const getCountries = async () => {
        try {
            const countries = await client.getEntries({
                content_type: 'country',
                select: 'fields'
            });

             const country = countries?.items.map(item => {
                 // @ts-ignore
                 const offices = item?.fields?.offices?.map(itm => {
                     // @ts-ignore
                     const img = itm?.fields?.img?.fields?.file?.url
                     return {
                         // @ts-ignore
                         ...itm.fields,
                         img
                     }
                 })

                 return{
                     // @ts-ignore
                     ...item.fields,
                     offices
                 }
             })

            return country


        } catch (err) {
            console.log(err)
        }
    }

    return {getContinents,getCountries}
}

export default useContentful;